import ApiCore from './ApiCore';

import { clearObject } from '../helpers';
// import { ResponseRecorderService } from './ResponseRecorderService';
import { VFNService } from './VFNService';
import sondaggi from '../data/sondaggio.json'
import campioni from '../data/campione.json'
import dati from '../data/parametro.json'


export class DatabaseService extends ApiCore {


  listSiti() {
    return new Promise((resolve, reject) => {
      this.instance.get('siti/list').then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  getSito(id) {
    return new Promise((resolve, reject) => {
      this.instance.get('siti/' + id).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  listMacrolotti(id = null) {
    return new Promise((resolve, reject) => {
      this.instance.get('macrolotti/list/' + (id ? id : "")).then(response => {
        resolve(response.data.macrolotti);
      }).catch(error => {
        reject(error);
      });
    });
  }

  getMacrolotto(id) {
    return new Promise((resolve, reject) => {
      this.instance.get('macrolotti/' + id).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  listSubaree(id = null) {
    return new Promise((resolve, reject) => {
      this.instance.get('subaree/' + (id ? "list/" + id : "search/1")).then(response => {
        resolve(response.data.subaree);
      }).catch(error => {
        reject(error);
      });
    });
  }

  getSubarea(id) {
    return new Promise((resolve, reject) => {
      this.instance.get('subaree/' + id).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  listSondaggi(id = null) {
    return new Promise((resolve, reject) => {
      this.instance.get('sondaggi/' + (id ? "list/" + id : "search/1")).then(response => {
        resolve(response.data.sondaggi);
      }).catch(error => {
        reject(error);
      });
    });
  }

  getSondaggio(id = null) {
    return new Promise((resolve, reject) => {
      this.instance.get('sondaggi/' + id).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  listCampioni(id = null) {
    return new Promise((resolve, reject) => {
      this.instance.get('campioni/' + (id ? "list/" + id : "search/1")).then(response => {
        resolve(response.data.campioni);
      }).catch(error => {
        reject(error);
      });
    });
  }

  getCampione(id = null) {
    return new Promise((resolve, reject) => {
      this.instance.get('campioni/' + id).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  listDati(id = null) {
    return new Promise((resolve, reject) => {
      this.instance.get('dati/' + (id ? "list/" + id : "search/1")).then(response => {
        resolve(response.data.dati);
      }).catch(error => {
        reject(error);
      });
    });
  }

  listParametri() {
    return new Promise((resolve, reject) => {
      this.instance.get('parametri/list').then(response => {
        resolve(response.data.parametri);
      }).catch(error => {
        reject(error);
      });
    });
  }

  listDocumenti(site, type) {
    return new Promise((resolve, reject) => {
      this.instance.get('documents/list/' + site + '/' + type).then(response => {
        resolve(response.data.documents_url);
      }).catch(error => {
        reject(error);
      });
    });
  }

  listUtenti() {
    return new Promise((resolve, reject) => {
      this.instance.get('users/list').then(response => {
        resolve(response.data.users);
      }).catch(error => {
        reject(error);
      });
    });
  }

  getUtente(id = null) {
    return new Promise((resolve, reject) => {
      this.instance.get('users/' + id).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  createUtente(params = {}) {
    return new Promise((resolve, reject) => {
      this.instance.post('users', {
        ...params,
        groups: []
        // "attributes": params
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  updateUtente(id = null, params = {}) {
    return new Promise((resolve, reject) => {
      this.instance.put('users/' + id,
        {
          ...clearObject(params, ["given_name", "family_name", "address"])
        }
      ).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  deleteUtente(id = null, params = {}) {
    return new Promise((resolve, reject) => {
      this.instance.delete('users/' + id).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  promoteUtente(id = null) {
    return new Promise((resolve, reject) => {
      this.instance.put('users/' + id + '/group', {
        "groups": ["CesiAdmin"]
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  demoteUtente(id = null) {
    return new Promise((resolve, reject) => {
      this.instance.delete('users/' + id + '/group', {
        groups: ["CesiAdmin"]
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  loadRdp(ids, type, fn) {
    return new Promise((resolve, reject) => {

      const params = Object.entries({
        fn,
        c: encodeURIComponent(ids.join('|')),
        t: type.toUpperCase()
      })
      .map(([k, v]) => `${k}=${v}`)
      .join('&')

      this.instance.get('documents/presigned_url/santa-barbara/rdp/?' + params).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  deleteRdp(id, type) {
    return this.instance.delete("documents/santa-barbara/?c=" + id + "&t=" + type.toUpperCase())
  }
}

class DBVFNService extends DatabaseService {
  /**
   * @param {VFNService} vfnService
   */
  constructor(vfnService) {
    super()
    this.vfnService = vfnService
  }

  async listSondaggi(id = null) {
    // const sondaggi = await super.listSondaggi(id)
    // const bad = sondaggi.filter(s => s.siglaSondaggio == undefined)
    // if (bad.length > 0) console.error("BAD SONDAGGI", bad)

    // return sondaggi
      
    const sondaggi = await super.listSondaggi(id)
    return await Promise.all(
      sondaggi.map(async s => ({
        ...s,
        coloreSondaggio: await this.coloreSondaggio(s.id) ?? s.coloreSondaggio
      }))
    )
  }

  async listCampioni(id = null) {
    // return await super.listCampioni(id);
    const campioni = await super.listCampioni(id)
    return await Promise.all(
      campioni.map(async c => ({
        ...c,
        coloreCampione: await this.coloreCampione(c.id) ?? c.coloreCampione
      }))
    ) 
  }

  async listDati(id = null) {
    const dati = await super.listDati(id)
    // return dati

    return await Promise.all(dati.map(async d => ({
      ...d,
      coloreCampione: await this.coloreCampione(d.campioneId) ?? d.coloreCampione,
      coloreSondaggio: await this.coloreSondaggio(d.sondaggioId) ?? d.coloreSondaggio,
      vfn: await this.vfnService.vfn(
        d.sondaggioId, d.campioneId, d.parametroId, 'T'
      )
    })))
  }

  async coloreSondaggio(id) {
    return this.plus10(await this.vfnService.coloreSondaggio(id))
  }

  async coloreCampione(id) {
    return this.plus10(await this.vfnService.coloreCampione(id))
  }

  plus10(x) {
    return (x != null) ? x + 10 : x
  }
}

const vfnService = new VFNService()
const service = new DBVFNService(vfnService)
export default service;
